<template>
  <header>
    <div class="header-content">
      <a
        href="/"
        class="header__logo-wrapper"
      >
        <img
          src="/images/logo.svg"
          alt="yousquared logo"
          class="header__logo-image"
        >
      </a>
      <navigation-component />
    </div>
  </header>
</template>
<script>
import NavigationComponent from '@/components/NavigationComponent.vue';

export default {
  name: 'HeaderComponent',
  components: {
    NavigationComponent,
  },
};
</script>
<style
  lang="scss"
  scoped
>
  header {
    background: $theme-color-accent;
    padding: 0 47px;
    box-sizing: border-box;

    @include respond-to(tablet) {
      padding: 0 10px;
    }
  }

  .header-content {
    max-width: 1224px;
    margin: 0 auto;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @include respond-to(tablet) {
      height: 50px;
    }
  }

  .header {
    &__logo-wrapper {
      position: absolute;
      max-width: 1224px;
      width: 100%;
      display: block;
      top: 25px;
      left: 0;
      right: 0;
      margin: 0 auto;

      @include respond-to(tablet) {
        top: 15px;
      }
    }

    &__logo-image {
      max-width: 197px;
      margin: 0 auto;
      display: block;

      @include respond-to(tablet) {
        max-width: 124px;
      }
    }
  }
</style>
